import React from 'react';

// @ts-ignore
import Icon from 'assets/images/trojanSvg/mice-green-75.svg';

const MiceIcon_1: React.FC = () => {
  return <img src={Icon} height={16} alt="Mice amount 1 Icon" />;
};

export default MiceIcon_1;
